<template>
    <b-modal
        :ref="modalRef"
        title-tag="h2"
        :title="titleAction"
        lazy
        @shown="shown"
    >
        <div>
            <div v-if="warningMessagePayment">
                <div class="alert-wrapper">
                    <div
                        class="alert alert-warning alert-dismissible"
                        role="alert"
                    >
                        {{ warningMessagePayment }}
                    </div>
                </div>
            </div>

            <b-form-group label-for="date" label="Date:" label-cols="4">
                <date-picker
                    :config="datePickerOptions"
                    v-model="selectedDate"
                    v-validate="'required'"
                    class="form-control"
                    placeholder="Date (required)"
                    :class="{ 'border-danger': errors.has('date') }"
                    name="date"
                ></date-picker>
            </b-form-group>
            <b-form-group
                v-if="!invoicePage"
                label-for="client_id"
                label="Client:"
                label-cols="4"
            >
                <div class="p-2" v-if="writeOff">
                    {{ writeOff.client.display_name || writeOff.client.label }}
                </div>
                <vet-select
                    v-else
                    id="client_id"
                    ref="client"
                    v-model="selectedClient"
                    :show-menu="false"
                    placeholder="Client name (required)"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('client_id') }"
                    name="client_id"
                    module="client"
                />
            </b-form-group>
            <b-form-group
                v-if="(writeOff && !invoicePage)"
                label-for="invoice"
                label="Invoice:"
                label-cols="4"
            >
                <div class="p-2">
                    {{ writeOff.invoice.name }}
                </div>
            </b-form-group>
            <ValidationProvider
                v-else-if="!writeOff"
                rules="required"
                ref="invoiceValidator"
                name="invoice"
            >
                <b-form-group
                    label-for="invoice"
                    label="Invoice:"
                    label-cols="4"
                    slot-scope="{ errors }"
                >
                    <select
                        v-model="selectedInvoice"
                        class="form-control"
                        :class="{
                            'border-danger': errors[0]
                        }"
                        :disabled="invoiceList.length == 0"
                    >
                        <option
                            :value="null"
                            v-if="invoiceList.length > 0"
                            disabled
                            >Please select an invoice</option
                        >
                        <option :value="null" v-else disabled
                            >No Invoice Available</option
                        >
                        <option :value="'all'" v-if="invoiceList.length > 0"
                            >All Open Invoices</option
                        >
                        <option
                            v-for="opt in invoiceList"
                            :key="opt.id"
                            :value="opt"
                            >{{ opt.name }}</option
                        >
                    </select>
                </b-form-group>
            </ValidationProvider>
            <b-form-group label-for="amount" label="Amount:" label-cols="4">
                <div class="p-2">
                    {{ _toCurrency(amount) }}
                </div>
            </b-form-group>
            <b-form-group label-for="note" label="Notes:" label-cols="4">
                <b-form-textarea
                    v-model="notes"
                    placeholder="Notes (optional)"
                    rows="3"
                    name="note"
                ></b-form-textarea>
            </b-form-group>
        </div>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                :isDisabled="isHasUsersChooseInvoice"
                ok-title="Save"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import { forEach } from "lodash";
import Billings from "@/services/client-billings";
import BillingWriteOffServices from "@/services/billing/billing-writeoff";
import { ValidationProvider } from "vee-validate";

export default {
    components: {
        vetSelect: () => import("@/module/commons/vet-select.vue"),
        modalFooter: () => import("@/components/elements/modal-footer"),
        ValidationProvider
    },
    props: {
        modalRef: {
            type: String,
            required: true
        },
        writeOff: {
            type: Object,
            default: null
        },
        invoicePage: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            datePickerOptions: {
                useCurrent: true,
                format: "DD/MM/YYYY"
            },
            selectedDate: null,
            selectedClient: null,
            selectedInvoice: null,
            invoiceList: [],
            amount: 0.0,
            notes: null,
            isLoading: false
        };
    },
    computed: {
        titleAction() {
            return this.writeOff
                ? this.invoicePage
                    ? this.invoicePage.new
                        ? "Write Off Invoice"
                        : "Edit Write Off"
                    : "Edit Write Off"
                : "New Write Off";
        },
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.writeOff && this.writeOff.invoice_id
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.writeOff.invoice_id
                  )
                : "";
        }
    },
    watch: {
        selectedClient(newValue) {
            if (newValue) {
                this.invoiceList = [];
                this.selectedInvoice = null;
                this.getInvoiceList(newValue.id);
            }
        },
        selectedInvoice(newValue) {
            if (newValue) {
                if (newValue === "all") {
                    let total = 0;
                    forEach(this.invoiceList, function (inv) {
                        total = total + Number(inv.balance);
                    });

                    this.amount = total;
                } else {
                    this.amount = Number(newValue.balance);
                }
            }
        }
    },
    methods: {
        setDefaultDate() {
            this.selectedDate = this._now().toFormat(this._dateFormat);
        },
        open() {
            this.$refs[this.modalRef].show();

            this.$nextTick(() => {
                this.datePickerOptions.format = this.getDateFormat();

                if (this.writeOff) {
                    this.setDate();
                    this.setClient();
                    this.amount = _.clone(this.writeOff.amount);
                    this.notes = _.clone(this.writeOff.note);
                } else {
                    this.setDefaultDate();
                }
            });
        },
        shown() {
            if (!this.writeOff) {
                this.$refs.client.focus();
            }
        },
        setDate() {
            if (this.writeOff.writeoff_date) {
                this.selectedDate = this._carbonDateDisplay(
                    this.writeOff.writeoff_date
                );
            } else {
                this.setDefaultDate();
            }
        },
        setClient() {
            this.selectedClient = {
                id: this.writeOff.client.id,
                label: this.writeOff.client.display_name
            };
        },
        async getInvoiceList(clientId) {
            if (this.writeOff == null) {
                let response = await Billings.getInvoices(clientId, true);

                if (response) {
                    this.invoiceList = _.get(response, "resource") || [];
                }
            }
        },
        async save() {
            let valid = await this.$validator.validateAll();
            let invoiceValid = this.writeOff
                ? { valid: true }
                : await this.$refs.invoiceValidator.validate();
            if (!valid || !invoiceValid.valid) {
                return false;
            }

            this.isLoading = true;

            let params = {
                date: this._fromDateStrToDateTime(this.selectedDate, true),
                client_id: this.selectedClient.id,
                invoice_id: this.writeOff
                    ? this.writeOff.invoice_id
                    : this.selectedInvoice == "all"
                    ? this.selectedInvoice.toUpperCase()
                    : this.selectedInvoice.id,
                amount: this.amount,
                note: this.notes
            };

            if (this.invoicePage) {
                this.invoicePage.new
                    ? this.newWriteOff(params)
                    : this.updateWriteOff(params);
            } else {
                this.writeOff
                    ? this.updateWriteOff(params)
                    : this.newWriteOff(params);
            }
        },
        newWriteOff(params) {
            BillingWriteOffServices.writeOffInvoiceCreate(params)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.messages);
                        this.$emit("reload");
                    } else {
                        this._message(response.messages, "danger");
                    }

                    this.close();
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to create write off",
                        "danger"
                    );
                    this.close();
                    console.error(error);
                });
        },
        updateWriteOff(params) {
            BillingWriteOffServices.writeOffInvoiceUpdate(
                params,
                this.writeOff ? this.writeOff.id : null
            )
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.messages);
                        this.$emit("reload");
                    } else {
                        this._message(response.messages, "danger");
                    }

                    this.close();
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to create write off",
                        "danger"
                    );
                    this.close();
                    console.error(error);
                });
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        }
    }
};
</script>
